'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _noImportant = require('aphrodite/no-important');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Static Amount that contains the currency symbol, read-only amount, and the currency code
 * - used for guest pay from a request
 */

var SYMBOL_MAXWIDTH = 40;
var STYLES = _noImportant.StyleSheet.create({
	currencySymbol: {
		width: SYMBOL_MAXWIDTH,
		display: 'inline-block',
		verticalAlign: 'super',
		textAlign: 'right',
		fontSize: 20,
		color: '#5a5a5a'
	},
	amount: {
		verticalAlign: 'middle',
		fontSize: 55,
		lineHeight: '55px',
		color: '#2c2e2f'
	},
	currencyCode: {
		lineHeight: '34px',
		color: '#000'
	}
});

var StaticAmount = function StaticAmount(_ref) {
	var currencySymbol = _ref.currencySymbol,
	    amount = _ref.amount,
	    currencyCode = _ref.currencyCode,
	    textColor = _ref.textColor;

	var textColorStyle = { color: '' + textColor };
	return _react2.default.createElement(
		'div',
		{ style: { textAlign: 'center' } },
		_react2.default.createElement(
			'div',
			{ style: { textIndent: -SYMBOL_MAXWIDTH } },
			_react2.default.createElement(
				'span',
				{ className: (0, _noImportant.css)(STYLES.currencySymbol), style: textColorStyle },
				currencySymbol
			),
			_react2.default.createElement(
				'span',
				{ className: (0, _noImportant.css)(STYLES.amount) + ' vx_text-3_lighter', style: textColorStyle },
				amount
			)
		),
		_react2.default.createElement(
			'div',
			{ className: (0, _noImportant.css)(STYLES.currencyCode), style: textColorStyle },
			currencyCode
		)
	);
};

StaticAmount.propTypes = {
	currencySymbol: _react.PropTypes.string.isRequired,
	amount: _react.PropTypes.string.isRequired,
	currencyCode: _react.PropTypes.string.isRequired,
	textColor: _react.PropTypes.string
};

exports.default = StaticAmount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/StaticAmount.js
// module id = 821
// module chunks = 5